import { ScrollTop } from '@/components/element/ScrollTop';
import { QuotationTaskEditForm } from '@/components/features/tasks/quotation/[quotation_task_id]/QuotationTaskEditForm';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentQuotationTask } from '@/providers/QuotationTaskProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';

export const BackofficeQuotationTaskEdit = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { quotationTask: task } = useCurrentQuotationTask();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('見積申請タスク編集'), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `見積申請タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/quotation_tasks` },
        {
          label: `見積申請タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/sales_orders/${_so_!.id}/quotation_tasks/${
            task!.id
          }`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <QuotationTaskEditForm />
    </WorkspaceLayout>
  );
};
